module.exports = __webpack_public_path__ + "static/media/indian-who-we-are-hero-xs.f703f384.jpg";